/** Dados públicos de contato da FabChat / FabTech (rodapé, JSON-LD, páginas de confiança). */

export const FABCHAT_LEGAL_NAME = "FabTech";
export const FABCHAT_CNPJ = "64.052.610/0001-11";
export const FABCHAT_SUPPORT_EMAIL = "atendimento.fabtech@gmail.com";
/** E.164 para schema.org telephone */
export const FABCHAT_SUPPORT_PHONE_E164 = "+5551980577709";

export const FABCHAT_DEFAULT_API_GATEWAY_URL =
  "https://tzgfynjxvuvuymfxicmf.supabase.co/functions/v1/api-gateway";

export const FABCHAT_DEFAULT_MCP_URL =
  "https://tzgfynjxvuvuymfxicmf.supabase.co/functions/v1/mcp";
